import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './Footer.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    setIsPrivacyModalOpen(true);
  };

  const closePrivacyModal = () => {
    setIsPrivacyModalOpen(false);
  };

  const PrivacyModal = () => {
    if (!isPrivacyModalOpen) return null;

    return createPortal(
      <div className="privacy-modal-overlay" onClick={closePrivacyModal}>
        <div className="privacy-modal" onClick={(e) => e.stopPropagation()}>
          <div className="privacy-modal-content">
            <h2 className="privacy-modal-title">Политика конфиденциальности</h2>
            <div className="privacy-modal-text">
              <p>Настоящая Политика конфиденциальности определяет порядок обработки и защиты информации о Пользователях, которую сайт shai.pro (далее – «Сайт») может получить во время использования ими Сайта, его сервисов, программ и продуктов.</p>

              <h3>1. ОПРЕДЕЛЕНИЕ ТЕРМИНОВ</h3>
              <p>1.1. В настоящей Политике конфиденциальности используются следующие термины:</p>
              <p>1.1.1. «Администрация сайта (далее – Администрация)» – уполномоченные сотрудники, действующие от имени владельца сайта shai.pro, которые организуют и осуществляют обработку персональных данных, а также определяют цели их обработки, состав данных и действия (операции), совершаемые с ними.</p>
              <p>1.1.2. «Персональные данные» – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).</p>
              <p>1.1.3. «Обработка персональных данных» – любое действие (операция) или совокупность действий (операций), совершаемых с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение, использование, передачу, обезличивание, блокирование, удаление и уничтожение.</p>
              <p>1.1.4. «Конфиденциальность персональных данных» – обязательное требование для Администрации и иных лиц, получивших доступ к персональным данным, не допускать их распространения без согласия субъекта или иного законного основания.</p>
              <p>1.1.5. «Пользователь сайта (далее – Пользователь)» – лицо, имеющее доступ к Сайту shai.pro через сеть Интернет и использующее его.</p>
              <p>1.1.6. «Cookies» – небольшой фрагмент данных, отправленный веб-сервером и хранимый на устройстве Пользователя, который передается веб-серверу при каждом обращении к Сайту.</p>
              <p>1.1.7. «IP-адрес» – уникальный сетевой адрес узла в компьютерной сети, построенной по протоколу IP.</p>

              <h3>2. ОБЩИЕ ПОЛОЖЕНИЯ</h3>
              <p>2.1. Использование Пользователем Сайта shai.pro означает безоговорочное согласие с настоящей Политикой конфиденциальности и условиями обработки его персональных данных.</p>
              <p>2.2. В случае несогласия с условиями Политики Пользователь должен немедленно прекратить использование Сайта.</p>
              <p>2.3. Настоящая Политика применяется исключительно к сайту shai.pro. Сайт не контролирует и не несет ответственности за сайты третьих лиц, на которые Пользователь может перейти по ссылкам, доступным на shai.pro.</p>
              <p>2.4. Администрация не проверяет достоверность персональных данных, предоставляемых Пользователем.</p>

              <h3>3. ПРЕДМЕТ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ</h3>
              <p>3.1. Настоящая Политика конфиденциальности устанавливает обязательства Администрации по неразглашению и обеспечению защиты конфиденциальности персональных данных, которые Пользователь предоставляет при использовании Сайта, включая регистрацию, оформление запросов или подписку.</p>
              <p>3.2. Персональные данные, разрешенные к обработке, предоставляются Пользователем путем заполнения форм на Сайте shai.pro и могут включать в себя следующую информацию:</p>
              <p>3.2.1. Фамилию, имя, отчество Пользователя;</p>
              <p>3.2.2. Контактный телефон Пользователя;</p>
              <p>3.2.3. Адрес электронной почты (e-mail);</p>
              <p>3.2.4. Иную информацию, необходимую для целей, указанных в разделе 4.</p>
              <p>3.3. Иная техническая информация (история посещений, используемые браузеры и операционные системы, данные cookies, IP-адреса и т.д.) подлежит надежному хранению и нераспространению, за исключением случаев, предусмотренных в п.п. 5.2. и 5.3. настоящей Политики.</p>

              <h3>4. ЦЕЛИ СБОРА ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ</h3>
              <p>4.1. Администрация использует персональные данные Пользователя в следующих целях:</p>
              <p>4.1.1. Идентификация Пользователя для использования сервисов Сайта.</p>
              <p>4.1.2. Предоставление Пользователю доступа к персонализированным ресурсам Сайта.</p>
              <p>4.1.3. Установление с Пользователем обратной связи, обработка его запросов и заявок.</p>
              <p>4.1.4. Подтверждение достоверности и полноты предоставленных персональных данных.</p>
              <p>4.1.5. Предоставление эффективной клиентской и технической поддержки.</p>
              <p>4.1.6. Предоставление Пользователю с его согласия информации об обновлениях продукции, специальных предложениях, новостной рассылки и иных сведений.</p>

              <h3>5. СПОСОБЫ И СРОКИ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ</h3>
              <p>5.1. Обработка персональных данных Пользователя осуществляется без ограничения срока законными способами.</p>
              <p>5.2. Пользователь соглашается с тем, что Администрация вправе передавать персональные данные третьим лицам (например, курьерским службам, поставщикам услуг) исключительно для целей выполнения обязательств перед Пользователем.</p>
              <p>5.3. Персональные данные Пользователя могут быть переданы уполномоченным органам государственной власти только по основаниям и в порядке, установленным законодательством.</p>
              <p>5.4. Администрация принимает необходимые организационные и технические меры для защиты персональной информации Пользователя от неправомерного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий третьих лиц.</p>

              <h3>6. ОБЯЗАТЕЛЬСТВА СТОРОН</h3>
              <p>6.1. Пользователь обязан:</p>
              <p>6.1.1. Предоставить достоверную информацию о персональных данных, необходимую для пользования Сайтом.</p>
              <p>6.1.2. Обновлять предоставленную информацию в случае ее изменения.</p>
              <p>6.2. Администрация обязана:</p>
              <p>6.2.1. Использовать полученную информацию исключительно для целей, указанных в настоящей Политике.</p>
              <p>6.2.2. Обеспечить конфиденциальность персональных данных и не разглашать их без предварительного письменного разрешения Пользователя, за исключением случаев, предусмотренных законом.</p>
              <p>6.2.3. Принимать меры предосторожности для защиты конфиденциальности персональных данных.</p>

              <h3>7. ОТВЕТСТВЕННОСТЬ СТОРОН</h3>
              <p>7.1. Администрация несет ответственность за убытки, понесенные Пользователем в связи с неправомерным использованием его персональных данных, в соответствии с законодательством.</p>
              <p>7.2. Администрация не несет ответственности за утрату или разглашение Конфиденциальной информации, если она:</p>
              <p>7.2.1. Стала публичным достоянием до ее утраты или разглашения.</p>
              <p>7.2.2. Была получена от третьей стороны до момента ее получения Администрацией.</p>
              <p>7.2.3. Была разглашена с согласия Пользователя.</p>

              <h3>8. РАЗРЕШЕНИЕ СПОРОВ</h3>
              <p>8.1. Все споры подлежат разрешению путем переговоров. Обязательным предварительным этапом до обращения в суд является предъявление письменной претензии.</p>
              <p>8.2. Получатель претензии в течение 30 календарных дней со дня ее получения письменно уведомляет заявителя о результатах рассмотрения.</p>
              <p>8.3. При недостижении соглашения спор подлежит разрешению в судебном порядке в соответствии с действующим законодательством.</p>

              <h3>9. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h3>
              <p>9.1. Администрация вправе вносить изменения в настоящую Политику конфиденциальности в одностороннем порядке без предварительного согласия Пользователя.</p>
              <p>9.2. Новая редакция Политики вступает в силу с момента ее размещения на Сайте shai.pro, если иное не предусмотрено новой редакцией.</p>
              <p>9.3. Все предложения или вопросы по настоящей Политике конфиденциальности следует направлять по адресу электронной почты: info@shai.pro.</p>
            </div>
            <button className="privacy-modal-close" onClick={closePrivacyModal}>
              Закрыть
            </button>
          </div>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <footer className="footer" id="contacts">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo-section">
            <div className="footer-logo">
              <img 
                src="/logos/shai-pro.png" 
                alt="shai.pro" 
                className="footer-logo-image"
              />
            </div>
            <div className="footer-social">
              <a 
                href="https://www.linkedin.com/company/shai-pro-ai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a 
                href="https://www.facebook.com/people/Shai-Pro/61579407922158/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Facebook"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/shai__pro/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Instagram"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div className="footer-navigation">
            <div className="footer-nav-column">
              <h4 className="footer-nav-title">{t.footerProducts}</h4>
              <ul className="footer-nav-list">
                <li>
                  <a href="https://shai.pro/products" className="footer-nav-link">{t.footerProductAgents}</a>
                </li>
                <li>
                  <a href="https://shai.pro/industries" className="footer-nav-link">{t.footerProductIndustries}</a>
                </li>
                <li>
                  <a href="https://shai.pro/404" className="footer-nav-link">{t.footerProductCases}</a>
                </li>
              </ul>
            </div>
            
            <div className="footer-nav-column">
              <h4 className="footer-nav-title">{t.footerCompany}</h4>
              <ul className="footer-nav-list">
                <li>
                  <a href="https://shai.pro/404" className="footer-nav-link">{t.footerCompanyAbout}</a>
                </li>
                <li>
                  <a href="https://shai.pro/404" className="footer-nav-link">{t.footerCompanyCareer}</a>
                </li>
                <li>
                  <a href="https://shai.pro/404" className="footer-nav-link">{t.footerCompanyContacts}</a>
                </li>
              </ul>
            </div>
            
            <div className="footer-nav-column">
              <h4 className="footer-nav-title">{t.footerLegal}</h4>
              <ul className="footer-nav-list">
                <li>
                  <button onClick={handlePrivacyClick} className="footer-nav-link footer-nav-button">{t.footerLegalPrivacy}</button>
                </li>
                <li>
                  <a href="https://shai.pro/404" className="footer-nav-link">{t.footerLegalOffer}</a>
                </li>
                <li>
                  <a href="https://shai.pro/404" className="footer-nav-link">{t.footerLegalSecurity}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-divider"></div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">{t.footerCopyright}</p>
        </div>
      </div>
      
      <PrivacyModal />
    </footer>
  );
};

export default Footer;

